import React from 'react'
import { Avatar, makeStyles, Typography } from '@material-ui/core'
import { getAvatarLetters } from '../../services/helpers'
import { Link as RouterLink } from 'react-router-dom'
import { purple } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	nameContainer: {
		display: 'flex',
		alignItems: 'center',
		flex: 1,
		'&.deactivated': {
			opacity: '0.6'
		},
		'& > a': {
			textDecoration: 'none',
			color: purple[500]
		}
	},
	avatar: {
		width: '2.5rem',
		height: '2.5rem',
		fontSize: '1.25rem'
	},
	avatarSmall: {
		width: '2rem',
		height: '2rem',
		fontSize: '1rem'
	},
	name: {
		fontSize: '1rem',
		lineHeight: '22px',
		marginLeft: '1rem'
	},
	nameSmall: {
		fontSize: '.9rem',
		lineHeight: '22px',
		marginLeft: '1rem'
	}
}))

const PetAvatar = ({ imageUrl = '', petName = 'Doggo', link = null, size = 'regular' }) => {
	const classes = useStyles()
	return (
		<div className={classes.nameContainer}>
			<Avatar
				className={size === 'regular' ? classes.avatar : classes.avatarSmall}
				alt={petName}
				src={imageUrl > '' ? imageUrl : null}>
				{getAvatarLetters(petName)}
			</Avatar>
			{link ? (
				<Typography component={RouterLink} to={link} className={classes.name} variant="overline">
					{petName}
				</Typography>
			) : (
				<Typography variant="overline" className={size === 'regular' ? classes.name : classes.nameSmall}>
					{petName}
				</Typography>
			)}
		</div>
	)
}

export default PetAvatar
